<template>
    <div>
        <div class="mt-3">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header font-weight-bold">
                            Editar Jurado
                        </div>
                        <div class="card-body">
                            <ValidationObserver v-slot="{ invalid }">
                                <form @submit.prevent="handleUpdateSworn">
                                    <ValidationProvider
                                        rules="required|alpha_spaces"
                                        name="nombre completo"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-group">
                                            <label for="inputAddress"
                                                >Nombre completo</label
                                            >
                                            <input
                                                type="text"
                                                class="form-control"
                                                id="inputAddress"
                                                placeholder="Ej: Juan Sebastían Rozo Gil"
                                                v-model="form.name"
                                            />
                                            <span class="text-danger mt-1">{{
                                                errors[0]
                                            }}</span>
                                        </div>
                                    </ValidationProvider>

                                    <div class="row row-cols-1 row-cols-md-3">
                                        <ValidationProvider
                                            rules="required|email"
                                            name="correo"
                                            v-slot="{ errors }"
                                        >
                                            <div class="form-group col">
                                                <label for="email"
                                                    >Correo electrónico</label
                                                >
                                                <input
                                                    type="email"
                                                    class="form-control"
                                                    id="email"
                                                    v-model="form.email"
                                                />
                                                <span
                                                    class="text-danger mt-1"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            rules="min:8"
                                            name="contraseña"
                                            v-slot="{ errors }"
                                            vid="password"
                                        >
                                            <div class="form-group col">
                                                <label for="password"
                                                    >Contraseña
                                                    <a
                                                        href="#"
                                                        @click="
                                                            showPassword(
                                                                'password'
                                                            )
                                                        "
                                                        >(Ver / Ocultar)</a
                                                    ></label
                                                >
                                                <input
                                                    type="password"
                                                    class="form-control"
                                                    id="password"
                                                    v-model="form.password"
                                                    name="password"
                                                />
                                                <span
                                                    class="text-danger mt-1"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </ValidationProvider>

                                        <ValidationProvider
                                            rules="min:8|confirmed:password"
                                            name="confirmar contraseña"
                                            v-slot="{ errors }"
                                        >
                                            <div class="form-group col">
                                                <label
                                                    for="password_confirmation"
                                                    >Confirmar contraseña
                                                    <a
                                                        href="#"
                                                        @click="
                                                            showPassword(
                                                                'password_confirmation'
                                                            )
                                                        "
                                                        >(Ver / Ocultar)</a
                                                    ></label
                                                >
                                                <input
                                                    type="password"
                                                    class="form-control"
                                                    id="password_confirmation"
                                                    name="password_confirmation"
                                                    v-model="
                                                        form.password_confirmation
                                                    "
                                                />
                                                <span
                                                    class="text-danger mt-1"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </ValidationProvider>
                                    </div>

                                    <ValidationProvider
                                        rules="required"
                                        name="tipo de jurado"
                                        v-slot="{ errors }"
                                    >
                                        <div class="form-row">
                                            <div class="card col-md-12 p-0">
                                                <div
                                                    class="card-header font-weight-bold"
                                                >
                                                    Tipo de jurado
                                                </div>
                                                <div
                                                    class="card-body card-type-judge"
                                                >
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="internal"
                                                            value="internal"
                                                            v-model="form.types"
                                                            @click="
                                                                controlSwornType()
                                                            "
                                                            disabled
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="internal"
                                                            >Interno</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="external"
                                                            value="external"
                                                            v-model="form.types"
                                                            @click="
                                                                controlSwornType()
                                                            "
                                                            disabled
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="external"
                                                            >Externo</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input"
                                                            id="optional"
                                                            value="optional"
                                                            v-model="form.types"
                                                            @click="
                                                                controlSwornTypeOptional()
                                                            "
                                                            disabled
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            for="optional"
                                                            >Opcional</label
                                                        >
                                                    </div>
                                                </div>
                                                <span
                                                    class="text-danger mx-4 mb-2"
                                                    >{{ errors[0] }}</span
                                                >
                                            </div>
                                        </div>
                                    </ValidationProvider>

                                    <div class="form-row">
                                        <div class="card col-md-12 p-0">
                                            <div
                                                class="card-header font-weight-bold"
                                            >
                                                Selecciona las categorías a
                                                asignar
                                            </div>
                                            <div
                                                class="card-body"
                                                v-if="
                                                    form.categories.length > 0
                                                "
                                            >
                                                <div
                                                    class="flex"
                                                    v-for="category in form.categories"
                                                    :key="category.category_id"
                                                >
                                                    <label class="col-md-6">{{
                                                        category.category_name
                                                    }}</label>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input category_evolution_item"
                                                            :id="`category_evolution_${category.category_id}`"
                                                            :data-category-id="
                                                                category.id
                                                            "
                                                            v-model="
                                                                category.evolution
                                                            "
                                                            name="evolution"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            :for="`category_evolution_${category.category_id}`"
                                                            >Evolución</label
                                                        >
                                                    </div>
                                                    <div
                                                        class="custom-control custom-switch col-md-3"
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            class="custom-control-input category_increase_item"
                                                            :id="`category_increase_${category.category_id}`"
                                                            :data-category-id="
                                                                category.id
                                                            "
                                                            v-model="
                                                                category.increase
                                                            "
                                                            name="increase"
                                                        />
                                                        <label
                                                            class="custom-control-label"
                                                            :for="`category_increase_${category.category_id}`"
                                                            >Crecimiento</label
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <button
                                        @click="changeView(1)"
                                        type="button"
                                        class="btn btn-outline-secondary my-2"
                                    >
                                        Volver
                                    </button>
                                    <button
                                        type="submit"
                                        class="btn btn-primary"
                                        :disabled="invalid"
                                    >
                                        Editar Jurado
                                    </button>
                                </form>
                            </ValidationObserver>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import helpers from "../../mixins/index";

export default {
    name: "SwornEdit",
    mixins: [helpers],
    props: {
        contestId: Number,
        params: {
            contestId: Number,
            swornId: Number,
            swornType: String,
        },
    },
    data() {
        return {
            form: {
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                types: [],
                categories: [],
                contest_id: this.contestId,
            },
        };
    },
    methods: {
        changeView(page) {
            this.$emit("change", page);
        },

        handleUpdateSworn(event) {
            const me = this;

            const user = me.params;

            me.loading();

            this.form.user_id = user.swornId;

            axios
                .put(`/api/sworn_/${user.swornId}`, this.form)
                .then(function (response) {
                    const { success, message } = response.data?.data;
                    if (success) {
                        me.closeLoading();
                        me.showActionSuccess(`${message}`);
                    }
                })
                .catch(function (error) {
                    let content = "";

                    if (error.response.status === 422) {
                        if (
                            typeof error.response?.data?.messages === "string"
                        ) {
                            content = error.response?.data?.messages;
                        } else {
                            const errors = Object.values(
                                error.response?.data?.messages
                            );
                            content = errors
                                .map((item) => `<li>${item}</li>`)
                                .join("");
                        }
                        me.showSwalError(`<ul>${content}</ul>`);
                    } else {
                        me.showSwalError(
                            "No fue posible procesar su solicitud, intente mas tarde."
                        );
                    }
                });
        },

        getSworn() {
            const me = this;

            const user = me.params;

            axios
                .get(
                    `/api/sworn_/show/${user.swornId}?type=${user.swornType}&contest_id=${me.contestId}`
                )
                .then(function (response) {
                    const { categories, email, name, types } =
                        response.data?.data;

                    me.form.categories = categories;
                    me.form.email = email;
                    me.form.name = name;
                    me.form.types = types;
                })
                .catch(function (error) {
                    me.showSwalError(
                        "No fue posible procesar su solicitud, intente mas tarde."
                    );
                });
        },

        controlSwornType() {
            const me = this;

            setTimeout(() => {
                if (
                    me.form.types.includes("internal") ||
                    me.form.types.includes("external")
                ) {
                    me.form.types = me.form.types.filter(
                        (el) => el !== "optional"
                    );
                }
            }, 100);
        },

        controlSwornTypeOptional() {
            const me = this;

            setTimeout(() => {
                if (me.form.types.includes("optional")) {
                    me.form.types = me.form.types.filter(
                        (el) => el === "optional"
                    );
                }
            }, 100);
        },
    },

    mounted() {
        this.getSworn();
    },
};
</script>
<style lang="scss" scoped>
.card-type-judge {
    padding: 20px 45px;
}

.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
